var CasePracticeMessageboxComponent = (function () {
    function CasePracticeMessageboxComponent() {
    }
    CasePracticeMessageboxComponent.prototype.ngOnInit = function () {
    };
    return CasePracticeMessageboxComponent;
}());
export { CasePracticeMessageboxComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/case-practice-hotel-component/case-practice-messagebox.component.ts.pre-build-optimizer.js